// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.txt-break[data-v-a69961e4] {word-break: break-word;}\n", ""]);
// Exports
module.exports = exports;
